import colorStyles from "../../../../src/pages/whats-new/atlassian-ui-refresh-updates/_images/color-styles.png";
import componentStyles from "../../../../src/pages/whats-new/atlassian-ui-refresh-updates/_images/component-styles.png";
import iconographyStyles from "../../../../src/pages/whats-new/atlassian-ui-refresh-updates/_images/iconography-styles.png";
import jiraScreenNewStyles from "../../../../src/pages/whats-new/atlassian-ui-refresh-updates/_images/jira-screen-new-styles.png";
import stylesDropdownCustom from "../../../../src/pages/whats-new/atlassian-ui-refresh-updates/_images/styles-dropdown-custom.png";
import stylesDropdownLegacy from "../../../../src/pages/whats-new/atlassian-ui-refresh-updates/_images/styles-dropdown-legacy.png";
import typographyStyles from "../../../../src/pages/whats-new/atlassian-ui-refresh-updates/_images/typography-styles.png";
import * as React from 'react';
export default {
  colorStyles,
  componentStyles,
  iconographyStyles,
  jiraScreenNewStyles,
  stylesDropdownCustom,
  stylesDropdownLegacy,
  typographyStyles,
  React
};